import React, { useEffect, useState } from 'react';
import MainLayout from '../../components/Layout/MainLayout';
import {
  TrendingUp,
  Users,
  ShoppingBag,
  DollarSign,
  ArrowUpRight,
  ArrowDownRight
} from 'lucide-react';
import './Dashboard.css';
import { useNavigate } from 'react-router-dom';
import { handleGetApi } from '../../api/api';
import Cookies from 'js-cookie';

const Dashboard = () => {
  const navigate = useNavigate();

  const token = JSON.parse(Cookies.get('auth_token'));
  const headers = { Authorization: token };

  const [stats, setStats] = useState([]);
  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDashboard = async () => {
    try {
      setLoading(true);

      const res = await handleGetApi('admin/get/dashboardSummary', headers);

      if (!res.success) {
        throw new Error(res.message || 'Failed to fetch dashboard');
      }

      const data = res.data;

      // ✅ dynamic stats
      setStats([
        {
          title: 'Total Revenue',
          value: `₹${data.totalRevenue}`,
          change: `${data.ordersChange}%`,
trend: data.ordersTrend,
          icon: <DollarSign size={24} />
        },
        {
          title: 'Total Orders',
          value: data.totalOrders,
         change: `${data.ordersChange}%`,
trend: data.ordersTrend,
          icon: <ShoppingBag size={24} />
        },
        {
          title: 'Avg. Order Value',
          value: `₹${data.avgOrderValue}`,
          change: `${data.ordersChange}%`,
trend: data.ordersTrend,
          icon: <TrendingUp size={24} />
        }
      ]);

      // ✅ recent orders
      setRecentOrders(data.recentOrders || []);

    } catch (error) {
      console.error('Dashboard Error:', error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  const getCustomerName = (order) => {
    if (order.customer_name) return order.customer_name;

    const first = order.first_name || '';
    const last = order.last_name || '';

    return `${first} ${last}`.trim() || 'N/A';
  };

  return (
    <MainLayout title="Dashboard Overview">
      <div className="dashboard-grid">

        {/* Stats */}
        <div className="stats-container">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-header">
                <div className="stat-icon-wrapper">{stat.icon}</div>

                <div className={`trend-badge ${stat.trend}`}>
                  {stat.trend === 'up'
                    ? <ArrowUpRight size={16} />
                    : <ArrowDownRight size={16} />
                  }
                  <span>{stat.change}</span>
                </div>
              </div>

              <div className="stat-info">
                <h3>{stat.value}</h3>
                <p>{stat.title}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Recent Orders */}
        <div className="dashboard-main-grid">
          <div className="dashboard-card orders-card">

            <div className="card-header">
              <h2>Recent Orders</h2>
              <button
                onClick={() => navigate('/orders')}
                className="view-all-btn"
              >
                View All
              </button>
            </div>

            <div className="table-responsive">
              <table className="orders-table">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>Product</th>
                    <th>Status</th>
                    <th>Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5">Loading...</td>
                    </tr>
                  ) : (
                    recentOrders.map((order) => (
                      <tr key={order.id}>
                        <td className="order-id">
                          {order.order_number}
                        </td>

                        <td>
                          {getCustomerName(order)}
                        </td>

                        <td>
                          {order.products || 'N/A'}
                        </td>

                        <td>
                          <span className={`status-pill ${order.order_status?.toLowerCase()}`}>
                            {order.order_status}
                          </span>
                        </td>

                        <td className="order-amount">
                          ₹{order.total_amount}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>

              </table>
            </div>

          </div>
        </div>

      </div>
    </MainLayout>
  );
};

export default Dashboard;